import Footer from "components/footer";
import Header from "components/header";

import PraticaLibera from "Pages/richiestePubbliche";

function App() {
	return (
		<div>
			<Header />

			<PraticaLibera />

			<div className="m-5"> </div>
			<div className="m-5"> </div>
			<Footer />
		</div>
	);
}

export default App;
